import {ITheme} from 'contexts/ThemeContext';
import {Platform} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  maxSize,
  minSize,
} from 'rn-responsive-styles';

export default (props: ITheme) =>
  CreateResponsiveStyle(
    {
      title: {
        fontSize: 17,
        fontWeight: '600',
        flex: 1,
      },
      container: {
        paddingLeft: 16,
        paddingRight: 16,
        borderRadius: 8,
        marginBottom: 16,
        justifyContent: 'center',
      },
      leftPart: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
      },
      arrowContainer: {
        marginRight: 12,
      },
      hideParticipantsContainer: {
        flexDirection: 'row',
        backgroundColor: props.colors.purple(0.13),
        width: 171,
        height: 40,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 16,
      },
      hideParticipantsImage: {
        width: 24,
        height: 24,
        marginRight: 8,
      },
      hideParticipantsText: {
        fontSize: 14,
        color: props.colors.purple(1),
        ...props.typography.interMedium,
      },
    },
    {
      [maxSize(DEVICE_SIZES.EXTRA_SMALL_DEVICE)]: {},
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {
        container: {
          backgroundColor: props.colors.white,
          marginTop: 20,
          marginLeft: 30,
          marginRight: 30,
          marginBottom: 12,
          borderRadius: 20,
          height: 59,
          ...(Platform.OS === 'web'
            ? {
                boxShadow: `0px 0px 10px ${props.colors.shadowGrey}`,
              }
            : {}),
        },
        title: {
          ...props.typography.interMedium,
          fontWeight: '500',
        },
      },
    },
  )();
